import { useAdd } from '@/pages/ExpenseDetail/comps/Add/index.jsx';
import { ExpenseDetailPage } from '@/pages/ExpenseDetail/index.jsx';
import { useModal } from '@ebay/nice-modal-react';
import { useNavigate } from 'react-router-dom';
import { useLongPress } from 'use-long-press';

const useExpenseAdd = ({ planId }: { planId: string }) => {
  const navigate = useNavigate();
  const { show: addShow } = useAdd({ planId });

  const modal = useModal(ExpenseDetailPage);

  const bind = useLongPress(() => {
    addShow({});
  }, {});

  return {
    ...bind(),
    onClick: () => {
      navigate('expense', {
        relative: 'route',
      });
      //  modal.show({ planId });
    },
  };
};

export default useExpenseAdd;
